// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"db16f4cf","977":"887bd2ff"}[chunkId] + ".chunk.js";
};